// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GroupFormGeneralMembers__members-aca62f {
  margin-top: 32px;
}

.GroupFormGeneralMembers__membersCount-a931c2 {
  font: var(--font-body-3);
  font: var(--font-spacing-body-3);
  color: var(--base-110);
  margin: 0 0 12px 24px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/components/GroupForm/GroupFormGeneral/GroupFormGeneralMembers/GroupFormGeneralMembers.styles.m.css"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,wBAAA;EACA,gCAAA;EACA,sBAAA;EACA,qBAAA;AACF","sourcesContent":[".members {\n  margin-top: 32px;\n}\n\n.membersCount {\n  font: var(--font-body-3);\n  font: var(--font-spacing-body-3);\n  color: var(--base-110);\n  margin: 0 0 12px 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"members": `GroupFormGeneralMembers__members-aca62f`,
	"membersCount": `GroupFormGeneralMembers__membersCount-a931c2`
};
module.exports = ___CSS_LOADER_EXPORT___;
